module.exports = "<section-header contents=\"{\n    goButton: true,\n    state: $ctrl.contents.state,\n    iconClass: 'fa-rocket',\n    title: 'Get started',\n    description: 'Welcome! Start by answering some questions on how you intend to use the service'\n}\"></section-header> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/sections/0-onboarding/onboarding.section-header.html
// module id = 4069
// module chunks = 86